import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LeadCaptureWidgetSubmission } from '../interfaces/lead-capture-submission.interface';
import { WidgetResponse } from '../interfaces/widget.interface';
import { FormSubmissionService } from './form-submission.service';
import { WidgetService } from './widget.service';

/** Legacy lead-capture v1 may pass partial survey payloads. */
type LeadFormSubmitPayload = LeadCaptureWidgetSubmission & {
  widget_id?: string;
  notes?: string;
  email?: string;
  [key: string]: unknown;
};

@Injectable({
  providedIn: 'root',
})
export class LeadCaptureService {
  private readonly widgetService = inject(WidgetService);
  private readonly formSubmissionService = inject(FormSubmissionService);

  getWidgetConfig(widgetId: string): Observable<WidgetResponse> {
    return this.widgetService.getWidgetDetails(widgetId);
  }

  submitLeadForm(widgetId: string, formData: LeadFormSubmitPayload) {
    return this.formSubmissionService.submitForm(widgetId, formData);
  }
}
